import { NgModule } from '@angular/core';
import { CommonModule, NgxCurrencyModule } from 'common';
import { FocusModule } from './focus/focus.module';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { LineOfCreditContentModule } from './line-of-credit-content/line-of-credit-content.module';
import { TermLoanContentModule } from './term-loan-content/term-loan-content.module';
import { LawCaseFinancingContentModule } from './law-case-financing-content/law-case-financing-content.module';
import { ShareOfferModule } from './share-offer/share-offer.module';
import { RepaymentNavigatorModule } from './repayment-navigator/repayment-navigator.module';
import { ProductNavigatorModule } from './product-navigator/product-navigator.module';
import { CalculatorHeadingModule } from './calculator-heading/calculator-heading.module';

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    NgxCurrencyModule.forRoot({
      align: "left",
      allowNegative: false,
      allowZero: true,
      decimal: ".",
      precision: 2,
      prefix: "$",
      suffix: "",
      thousands: ",",
      nullable: true
    }),
    FocusModule
  ],
  exports: [
    CommonModule,
    FlexLayoutModule,
    FocusModule,
    LineOfCreditContentModule,
    TermLoanContentModule,
    LawCaseFinancingContentModule,
    RepaymentNavigatorModule,
    ProductNavigatorModule,
    ShareOfferModule,
    CalculatorHeadingModule
  ]
})
export class SharedModule { }
